<template>
  <CRow>
    <CCol col="6" :md="{ offset: '3' }">
      <CCard>
        <CCardHeader color="dark" class="text-white">
          Dados do usuário
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol col="6">
              <CInput
                label="Nome"
                v-model.trim="form.name"
                :isValid="isValid('name')"
                :invalidFeedback="errorMessage('name')"
              />
            </CCol>
            <CCol col="6">
              <CInput
                label="Email"
                v-model="form.email"
                :isValid="isValid('email')"
                :invalidFeedback="errorMessage('email')"
              />
            </CCol>
          </CRow>

          <CRow>
            <CCol col="6" v-if="!passwordChange">
              <br />
              <center>
                <CButton
                  color="success"
                  @click="
                    passwordChange = passwordChange === true ? false : true
                  "
                >
                  Alterar senha
                </CButton>
              </center>
            </CCol>
            <CCol col="3" v-if="passwordChange">
              <CInput
                type="password"
                label="Senha"
                v-model="form.password"
                :isValid="isValid('password')"
                :invalidFeedback="errorMessage('password')"
              />
            </CCol>
            <CCol col="3" v-if="passwordChange">
              <CInput
                type="password"
                label="Confirma Senha"
                v-model="form.password_confirmation"
                :isValid="isValid('password_confirmation')"
                :invalidFeedback="errorMessage('password_confirmation')"
              />
            </CCol>
            <CCol col="6">
              <label>Perfis</label>
              <v-select
                :options="roles"
                multiple
                v-model="form.roles"
              ></v-select>
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CButton color="danger" @click="cancel">Cancelar</CButton>
          <CButton color="success" @click="save" :disabled="$v.form.$anyError"
            >Salvar</CButton
          >
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { required, minLength, email, sameAs } from "vuelidate/lib/validators";
import { myHelper } from "../../assets/helpers/helper.js";
import vSelect from "vue-select";
export default {
  name: "User",
  components: {
    vSelect,
  },

  data() {
    return {
      form: {
        name: "",
        email: "",
        password: "",
        password_confirmation: "",
        roles: [],
      },
      formErrors: {},
      roles: [],
      passwordChange: false,
      submitStatus: null,
      errorMessages: {
        name: {
          required: "Nome é obrigatório",
          minLength: "O nome precisa ter ao menos 4 caracteres",
        },
        email: {
          required: "O Email é obrigatório",
          email: "O Email precisa ser válido",
        },
        password: {
          required: "A senha é obrigatória",
          minLength: "A senha deve conter ao menos 8 caracteres",
        },
        password_confirmation: {
          sameAsPassword: "As senhas não coincidem",
        },
      },
    };
  },

  validations() {
    let validate = {
      form: {
        name: {
          required,
          minLength: minLength(4),
        },
        email: {
          required,
          email,
        },
        password: {},
        password_confirmation: {},
      },
    };

    if (this.$route.params.id == 0 || this.passwordChange) {
      validate.form.password = { required, minLength: minLength(8) };
      validate.form.password_confirmation = {
        required,
        sameAsPassword: sameAs("password"),
      };
    }

    return validate;
  },

  mounted() {
    this.$http
      .get("/api/roles")
      .then((res) => {
        if (res.status === 200) {
          this.roles = res.data.roles;
          for (let index = 0; index < this.roles.length; index++) {
            this.roles[index].label = myHelper.translateRole(
              this.roles[index].label
            );
          }
        }
      })
      .catch((error) => {});

    if (this.$route.params.id > 0) {
      this.$http
        .get("/api/users/" + this.$route.params.id)
        .then((res) => {
          if (res.status === 200) {
            this.form = res.data.user;
            for (let index = 0; index < this.form.roles.length; index++) {
              this.form.roles[index].label = myHelper.translateRole(
                this.form.roles[index].label
              );
            }
            this.$v.$touch();
          }
        })
        .catch((error) => {});
    } else {
      this.passwordChange = true;
      this.$v.$touch();
    }
  },
  methods: {
    isValid: function (k) {
      let ret =
        this.$v.form[k].$error !== undefined ? !this.$v.form[k].$error : true;

      if (this.formErrors[k] !== undefined) {
        ret = false;
      }

      return ret;
    },

    errorMessage: function (k) {
      if (this.formErrors[k] === undefined) {
        let v = this.$v.form[k];
        let obj = Object.keys(v);

        for (let i = 0; i < obj.length - 8; i++) {
          if (!v[obj[i]])
            if (this.errorMessages[k] !== undefined)
              return this.errorMessages[k][obj[i]] !== undefined
                ? this.errorMessages[k][obj[i]]
                : "Verifique o valor informado";
        }
      } else {
        return this.formErrors[k][0];
      }
    },

    cancel() {
      this.$swal({
        icon: "warning",
        title: "Atenção",
        text: "Deseja realmente cancelar?",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$router.push({ path: "/users" });
        }
      });
    },
    save() {
      this.formErrors = {};
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.$route.params.id == 0) {
          this.$http
            .post("/api/users", this.form)
            .then((res) => {
              if (res.status === 200) {
                if (res.data.code === 0) {
                  this.$swal({
                    icon: "success",
                    title: "Usuário adicionado com sucesso!",
                  });
                  this.$router.push({ path: "/users" });
                }
              } else {
                this.formErrors = res.data.errors;
              }
            })
            .catch((error) => {});
        } else {
          this.form.passwordChange = this.passwordChange;
          this.$http
            .put("/api/users/" + this.$route.params.id, this.form)
            .then((res) => {
              if (res.status === 200) {
                if (res.data.code === 0) {
                  this.$swal({
                    icon: "success",
                    title: "Alterações salvas com sucesso!",
                  });
                  this.$router.push({ path: "/users" });
                }
              }
            })
            .catch((error) => {});
        }
      }
    },
  },
};
</script>
<style scoped>
.card-footer button.btn-success {
  float: right;
}
.card-footer button.btn-danger {
  float: left;
}
@media (max-width: 575px) {
  .col-3,
  .col-6 {
    flex: none !important;
    max-width: 100% !important;
  }
}
</style>